import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import logo from '../../../assets/images/horizontal-darkblue.png';
import {buildWordpressUrl} from '../../../utils/routeHelper';

import './flowStepper.scss';

/**
 * The FlowStepper component.
 */
class FlowStepper extends React.Component {
  /**
   * Renders the component.
   *
   * @returns {{}}
   */
  render() {
    const {steps, currentStep, changeStep, disablePreviousButton} = this.props;
    const homeLink = buildWordpressUrl();
    const currentIndex = steps.findIndex((step) => step.key === currentStep);
    const previousStep = currentIndex > 0 ? steps[currentIndex - 1] : null;

    return (
      <>
      <div className={classNames('row nav p-3', {[`section${currentStep}`]: true})}>
        <div className="active-page-dot" />
        <div className="active-page-line" />
        <div className="col-md-3 col-12 d-flex align-items-center">
          <div>
            <a href={homeLink}>
              <img className="logo ml-3 p-2" src={logo} alt="logo" />
            </a>
          </div>
        </div>
        <div className="col-6 d-none d-md-flex align-items-center justify-content-center">
          {steps.map((step) => {
            const isDisabled = step.disabled;

            return (
              <button
                key={step.key}
                type="button"
                onClick={isDisabled ? undefined : () => changeStep(step.key)}
                disabled={isDisabled}
                style={{
                  opacity: currentStep !== step.key
                    // eslint-disable-next-line no-magic-numbers
                    ? 0.3
                    : 1,
                  cursor: isDisabled
                    ? 'not-allowed'
                    : 'pointer',
                }}
                className={classNames(
                  'btn btn-sm rounded-pill mr-2 section-button',
                  {
                    'btn-secondary': currentStep === step.key,
                    'btn-outline-secondary': currentStep !== step.key
                  }
                )}
              >
                {step.label}
              </button>
            );
          })}
        </div>
      </div>
      {(!disablePreviousButton) && (
        <div className="my-3 container">
          <a
            className="h6"
            tabIndex="0"
            onClick={() => changeStep(previousStep.key)}
          >
            {previousStep && `← ${previousStep.label}`}
          </a>
        </div>
      )}
      </>
    );
  }
}

FlowStepper.propTypes = {
  changeStep: PropTypes.func,
  currentStep: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  disablePreviousButton: PropTypes.bool,
  steps: PropTypes.array,
};

FlowStepper.defaultProps = {
  disablePreviousButton: false,
};

export default FlowStepper;

